function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { j as s } from "./index.es33.js";
import { useState as w } from "react";
import { clsx as t } from "./index.es105.js";
import { Typography as l } from "./index.es35.js";
import "./index.es36.js";
import { inputSelectors as y } from "./index.es107.js";
import { InputHint as N } from "./index.es108.js";
import e from "./index.es111.js";
import o from "./index.es117.js";
var E = function E(_ref) {
  var _ref$type = _ref.type,
    m = _ref$type === void 0 ? "text" : _ref$type,
    i = _ref.isError,
    x = _ref.hint,
    j = _ref.maxLength,
    _ref$placeholder = _ref.placeholder,
    c = _ref$placeholder === void 0 ? [] : _ref$placeholder,
    _ref$value = _ref.value,
    a = _ref$value === void 0 ? [] : _ref$value,
    u = _ref.onChange,
    d = _ref.label,
    f = _ref.onBlur,
    p = _ref.isDisabled;
  var _w = w(!1),
    _w2 = _slicedToArray(_w, 2),
    h = _w2[0],
    n = _w2[1];
  return s.jsxs("div", {
    children: [d && s.jsx(l.Body2, {
      as: "div",
      className: t(e.labelContainer, e.label),
      children: d
    }), s.jsxs("label", {
      className: t(e.container, _defineProperty(_defineProperty({}, e.containerWithError, i), e.containerDisabled, p)),
      children: [s.jsxs("div", {
        className: t(o.wrapper, e.wrapper, y.classNames.wrapper, _defineProperty(_defineProperty(_defineProperty({}, o.wrapperFocused, h), o.wrapperError, i), e.wrapperDisabledStyles, p)),
        children: [s.jsx(l.Body2, {
          className: t(e.input, o.input),
          as: "input",
          disabled: p,
          maxLength: j,
          type: m,
          value: a[0],
          placeholder: c[0] || "",
          onChange: function onChange(r) {
            return u === null || u === void 0 ? void 0 : u([r.target.value, a[1] || ""]);
          },
          onFocus: function onFocus() {
            return n(!0);
          },
          onBlur: function onBlur(r) {
            n(!1), f === null || f === void 0 ? void 0 : f("from", r);
          }
        }), s.jsx(l.Body2, {
          className: t(e.input, o.input),
          as: "input",
          disabled: p,
          type: m,
          value: a[1],
          placeholder: c[1] || "",
          onChange: function onChange(r) {
            return u === null || u === void 0 ? void 0 : u([a[0] || "", r.target.value]);
          },
          onFocus: function onFocus() {
            return n(!0);
          },
          onBlur: function onBlur(r) {
            n(!1), f === null || f === void 0 ? void 0 : f("to", r);
          }
        })]
      }), s.jsx(N, {
        isError: i,
        hint: x
      })]
    })]
  });
};
export { E as Twice };